module.exports = __webpack_public_path__ + "static/img/14003013.84f0cc0b.png";